/* eslint-disable complexity */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { toastError } from '@futrli/ui-components';
import {
  Logger,
  QUERY_PARAMS,
  getIntegrationsOnboardingUrl,
  useSessionStorage,
  PREDICT_PRODUCT_ID
} from '@futrli/shared-services';

import { sendEloquaRequest } from '../../../../auth/src/utils/eloqua';
import { FederatedSignInStorage } from '../../../../auth/src/federated-sign-in/types';
import { FEDERATED_SIGN_IN_STORE_KEY } from '../../../../auth/src/federated-sign-in/constants';
import { updateUserAttributes } from '../../../../auth/src/auth/redux-utils/actions';
import { getCustomBusinessPhoneNumber, getCustomBusinessType } from '../../../../auth/src/auth/service';
import { useAdditionalInfoForm } from './additional-info-form/use-additional-info-form';
import { OnboardingNavbar } from './onboarding-navbar';
import { AdditionalInfoForm } from './additional-info-form/additional-info-form';

export const XeroAdditional = () => {
  const [isLoading, setIsLoading] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [storage, _store, clearStorage] = useSessionStorage<FederatedSignInStorage | null>(
    FEDERATED_SIGN_IN_STORE_KEY,
    null
  );

  const formState = useAdditionalInfoForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    businessPhoneNumber,
    businessType,
    isValid,
    readPrivacy,
    receiveMarketingEmails,
    selectedCountry
  } = formState;

  const searchParams = new URLSearchParams(location.search);
  const workspaceId = searchParams.get(QUERY_PARAMS.WORKSPACE_ID);

  const handleNextClick = async () => {
    if (!workspaceId) {
      return;
    }

    const userAttributes = {
      ...getCustomBusinessPhoneNumber(businessPhoneNumber),
      ...getCustomBusinessType(businessType)
    };

    try {
      setIsLoading(true);
      await updateUserAttributes(userAttributes)(dispatch);
    } catch (e) {
      Logger.error(e as string);
      toastError();
    } finally {
      setIsLoading(false);
    }

    sendEloquaRequest(selectedCountry, businessPhoneNumber, !!receiveMarketingEmails, businessType);

    if (storage?.federatedIdentityProvider === 'Xero') {
      clearStorage();
    }
    navigate(getIntegrationsOnboardingUrl(workspaceId, '', PREDICT_PRODUCT_ID));
  };

  const submitFormDisabled = isLoading || !workspaceId || !readPrivacy || !selectedCountry || !isValid;

  return (
    <>
      <OnboardingNavbar />
      <AdditionalInfoForm {...formState} submitFormDisabled={submitFormDisabled} handleNextClick={handleNextClick} />
    </>
  );
};
